import { Menu, MenuProps } from "antd";
import { cx } from "class-variance-authority";

import { TabSpec } from "../../componentTypes/tab";
import { Tooltip } from "../Tooltip";

import * as theme from "./Tabs.css";

export interface TabsProps {
    className?: string;
    tabSpecs: TabSpec[];
    currentTabId: string;
    getPopupContainer?: MenuProps["getPopupContainer"];
}

export function Tabs({
    className,
    tabSpecs,
    currentTabId,
    getPopupContainer,
}: TabsProps) {
    if (tabSpecs.length === 0) {
        return null;
    }
    const items: MenuProps["items"] = tabSpecs.map((tab) => ({
        className: theme.menuItem,
        key: tab.id,
        onClick: (event) => tab.onClick({ ...event, item: tab }),
        disabled: tab.disabled !== undefined,
        label: <TabLabel tab={tab} />,
    }));
    return (
        <div className={cx(theme.menu, className)}>
            <Menu
                id={currentTabId}
                selectedKeys={[currentTabId]}
                mode="horizontal"
                items={items}
                getPopupContainer={getPopupContainer}
            />
        </div>
    );
}

interface TabLabelProps {
    tab: TabSpec;
}

function TabLabel({ tab }: TabLabelProps) {
    const label = <div id={tab.id}>{tab.label}</div>;
    switch (tab.disabled?.type) {
        case "DisabledWithReason":
            return (
                <Tooltip placement="bottom" title={tab.disabled.reason}>
                    {label}
                </Tooltip>
            );
        case "Disabled":
        case undefined:
            return label;
    }
}
